export const SUPER_ADMIN = "super admin";
export const ADMIN = "admin";
export const ACCOUNTANT = "accountant";
export const EMPLOYEE = "employee";
